export var ChartType;
(function (ChartType) {
    ChartType["income_spending"] = "income_spending";
    ChartType["over_time"] = "over_time";
    ChartType["categories"] = "categories";
})(ChartType || (ChartType = {}));
export const chartTypeToMinHeight = {
    [ChartType.income_spending]: 291,
    [ChartType.over_time]: 340,
    [ChartType.categories]: 404,
};
